/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc 校验图形验证码
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export class CheckImageCaptchaParams {
  constructor(public code: string, public uuid: string) {}
}

export default async function (
  params: CheckImageCaptchaParams,
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: boolean;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/member/captcha-verification`,

    params,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
